import React, { useEffect, useState } from 'react';
import { Spin, Result, Button } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../api/client';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setStatus('error'); setMessage('No token provided.'); return; }

    api.get(`/api/auth/verify-email?token=${token}`)
      .then(() => setStatus('success'))
      .catch(e => { setStatus('error'); setMessage(e.response?.data?.message || 'Invalid or expired link.'); });
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' }}>
      <div style={{ width: 440, background: '#fff', border: '1px solid #e8e8e8', borderRadius: 12, padding: 48, textAlign: 'center' }}>
        <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 32 }}>SGLearner</div>

        {status === 'loading' && <><Spin size="large" /><p style={{ color: '#888', marginTop: 16 }}>Verifying your email…</p></>}

        {status === 'success' && (
          <>
            <CheckCircleOutlined style={{ fontSize: 52, color: '#52c41a', marginBottom: 16 }} />
            <h2 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 8px' }}>Email verified!</h2>
            <p style={{ color: '#888', marginBottom: 24 }}>Your account is now active. You can log in.</p>
            <Button type="primary" size="large" block style={{ background: '#0a0a0a', border: 'none' }}
              onClick={() => navigate('/')}>
              Go to login
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <CloseCircleOutlined style={{ fontSize: 52, color: '#ff4d4f', marginBottom: 16 }} />
            <h2 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 8px' }}>Verification failed</h2>
            <p style={{ color: '#888', marginBottom: 24 }}>{message}</p>
            <Link to="/register">
              <Button size="large" block>Back to register</Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
